<template lang='pug'>
.notifications
  transition-group(name='list')
    md-notification(v-for='(n,index) in notifications',
                    :key='n',
                    :heading='n.heading',
                    :message='n.message',
                    :icon='n.icon',
                    :type='n.type',
                    :width='n.width',
                    :position='n.position',
                    :placement='n.placement',
                    :timeout='n.timeout',
                    :allowDismiss='n.allowDismiss',
                    :dismiss='n.dismiss'
                    :discard='n.discard'
                    :goto='n.goto'
                    :hide='n.component ? true : n.hide'
                    @onClose='onClose($event, n, index)')
      div(slot='message' v-if='n.component')
        component(:is='n.component')
</template>
<script>
import MdNotification from '@/core/components/mdNotification'

export default {
  name: 'md-notifications',
  components: {
    MdNotification
  },
  data() {
    return {
      notifications: this.$notifications.state
    }
  },
  methods: {
    removeNotification(index) {
      this.$notifications.removeNotification(index)
    },
    onClose(dismiss, notification, index) {
      // if native event do not send any data
      if (typeof notification.onClose === 'function') {
        // notification.onClose(dismiss ? dismiss.target ? null : dismiss : null)
        notification.onClose(dismiss ? dismiss.target ? undefined : dismiss : dismiss === '' ? '' : null)
      }

      this.removeNotification(index)
    }
  }
}

</script>
<style lang='scss' scoped>
.list-item {
  display: inline-block;
  margin-right: 10px;
}

.list-enter-active,
.list-leave-active {
  transition: all 1s;
}

.list-enter,
.list-leave-to {
  opacity: 0;
  transform: translateY(-30px);
}
</style>



// WEBPACK FOOTER //
// src/core/components/mdNotifications/index.vue